import globalStore from '@services/global.state';
import qs from 'qs';
import {getAllCasinoRedirect} from '@/common-pages/game-navigate';
import {goTo} from '@utils/route';

type NormalizeGamePushOptions = {
  gameUrl?: string;
  gameName?: string;
  otherGame?: boolean;
};

const createDefaultGameRoute =
  (route: string, defaultParams = {}) =>
  (params: any = {}) => ({
    route,
    params: {
      ...defaultParams,
      ...params,
    },
  });
const createMixLottery = createDefaultGameRoute('MixLottery');
const createMatka = createDefaultGameRoute('GameSatta');
const createOtherGame = createDefaultGameRoute('WebView', {
  header: true,
  hideAmount: true,
});
const createScratch = createDefaultGameRoute('Scratch', {
  hideInnerTitle: 1,
});
const createColor = createDefaultGameRoute('Color');
const createDice = createDefaultGameRoute('Dice');
const createKerala = createDefaultGameRoute('GameWebView', {
  type: 'kerala',
});
// goTo('Digit', {
//   id: item.id,
//   pickName: item.pickName,
//   pickGameType: item.cycle ? 'quick' : 'normal',
//   cycle: item.cycle,
// });

const createDigit = createDefaultGameRoute('Digit');

// color ✅
// dice ✅
// mix-lottery state-lottery ✅
// race ✅
// matka ✅
// kerala ✅
// quick 3d digit ❎
// 体育 ❎
// 其他游戏 ✅
const reflexRoute = new Map([
  ['/mix-lottery', createMixLottery],
  ['/game-satta', createMatka],
  ['/scratch', createScratch],
  ['/color', createColor],
  ['/dice', createDice],
  ['/game-kerala', createKerala],
  ['/digit', createDigit],
]);

function parseSelfDevelopedGameUrl(gameUrl = '') {
  const url = gameUrl.trim();
  if (!url || /^https?/.test(url)) {
    return;
  }
  const [routeLink, paramsJson = ''] = url.split('?');
  const routeParams = reflexRoute.get(routeLink.split('#')[0]);
  const params = qs.parse(paramsJson.split('#')[0]) as Record<string, any>;
  if (!routeParams || params.otherGame === 'true') {
    return;
  }
  return {
    routeParams,
    params,
  };
}

export function parseLocalGameUrlRoute(gameUrl = '', gameName?: string) {
  const parsedGameUrl = parseSelfDevelopedGameUrl(gameUrl);
  if (!parsedGameUrl) {
    return;
  }
  const {routeParams, params} = parsedGameUrl;
  return routeParams({
    ...params,
    ...(gameName ? {gameName} : {}),
  });
}

// 解析gameUrlv2
export function isOtherGame(url?: string) {
  return !parseSelfDevelopedGameUrl(url);
}

/**
 * @description 通过一个游戏id，获取其路由地址 包括SKYGAME 三方 体育
 * @param {Number | String} id
 * @param otherGame
 * */
export async function getGameById(id: number, otherGame = false) {
  const {gameName, gameUrl} = await getAllCasinoRedirect(id, otherGame);
  const routeData = parseLocalGameUrlRoute(gameUrl, gameName);
  if (routeData) {
    return routeData;
  }
  if (/^https?/.test(gameUrl)) {
    return createOtherGame({
      originUrl: gameUrl,
      headerTitle: gameName,
      gameName,
      gameUrl,
    });
  }
}

export async function normalizeGamePush(
  id: number,
  options: boolean | NormalizeGamePushOptions = false,
) {
  if (!id) {
    return;
  }
  const opts: NormalizeGamePushOptions =
    typeof options === 'boolean' ? {otherGame: options} : options;
  const {gameUrl, gameName, otherGame = false} = opts;
  if (otherGame && !globalStore.token) {
    goTo('Login');
    return;
  }
  try {
    globalStore.globalLoading.next(true);
    const routeData =
      (!otherGame && parseLocalGameUrlRoute(gameUrl, gameName)) ||
      (await getGameById(id, otherGame));
    if (routeData) {
      goTo(routeData.route, routeData.params);
    }
  } finally {
    globalStore.globalLoading.next(false);
  }
}
